// Centralized backend URL resolution.
//
// Priority:
// - Web: injected runtime config (window.__RUNTIME_CONFIG__.BACKEND_URL)
// - Expo: EXPO_PUBLIC_BACKEND_URL (recommended)
// - Legacy: BACKEND_URL
// - Fallback: provided argument
// - Default: http://localhost:4000

import { Platform } from 'react-native';
import Constants from 'expo-constants';

export function getBackendUrl(fallback?: string): string {
  const fromRuntime =
    typeof window !== 'undefined' && (window as any).__RUNTIME_CONFIG__ && (window as any).__RUNTIME_CONFIG__.BACKEND_URL;

  // Expo native: prefer app config `extra` injected via app.config.js / eas build
  let fromExpoExtra: string | undefined | null = undefined;
  try {
    fromExpoExtra = (Constants.expoConfig && (Constants.expoConfig.extra as any)?.BACKEND_URL) || (Constants.manifest && (Constants.manifest.extra as any)?.BACKEND_URL);
  } catch (_) {
    fromExpoExtra = undefined;
  }

  const fromExpoPublic = (process.env as any).EXPO_PUBLIC_BACKEND_URL;
  const fromLegacy = (process.env as any).BACKEND_URL;

  const raw = fromRuntime || fromExpoExtra || fromExpoPublic || fromLegacy || fallback || 'http://localhost:4000';
  let base = String(raw).trim();
  while (base.endsWith('/')) base = base.slice(0, -1);
  // Note: automatic rewrite from 'localhost' to '10.0.2.2' removed to avoid
  // unexpected URL substitutions between emulator and real devices.
  // Ensure the correct backend is provided via `BACKEND_URL` or
  // `EXPO_PUBLIC_BACKEND_URL` at build/start time.
  console.log('KAK_BACKEND_URL=', base);
  return base;
}
